(function () {
  'use strict';

  /* =========================================================
     CONFIG
  ========================================================= */

  const cfg = window.__cartDrawerConfig || {};

  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');

  const itemsContainer = document.getElementById('cart-drawer-items');
  const emptyState = document.getElementById('cart-drawer-empty');
  const footer = document.getElementById('cart-drawer-footer');
  const continueShopping = document.getElementById('cart-continue-shopping');
  const itemTemplate = document.getElementById('cart-item-template');
  const subtotalValue = document.getElementById('cart-subtotal-value');
  const tierMessage = document.getElementById('cart-tier-message');
  const discountFeedback = document.getElementById('cart-discount-feedback');
  const titleCount = document.getElementById('cart-drawer-count');

  if (!drawer || !overlay || !itemsContainer || !itemTemplate) {
    return;
  }

  /* =========================================================
     STATE
  ========================================================= */

  let cartData = null;
  let busy = false;
  let renderSeq = 0;
  let lastAddAt = 0;

  const productCache = new Map();

  /* =========================================================
     MONEY
  ========================================================= */

  function money(cents) {
    return '₹' + (Number(cents || 0) / 100).toLocaleString('en-IN', {
      maximumFractionDigits: 2
    });
  }

  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[char];
    });
  }

  /* =========================================================
     BUSY STATE
  ========================================================= */

  function setBusy(next) {
    busy = !!next;
    drawer.classList.toggle('is-busy', busy);

    drawer
      .querySelectorAll(
        '.cart-item__qty-btn, .cart-item__remove, .steal-deal-card__add-btn'
      )
      .forEach(function (button) {
        button.disabled = busy;
      });
  }

  /* =========================================================
     FEEDBACK
  ========================================================= */

  function feedback(message, error) {
    if (!discountFeedback) return;
    discountFeedback.textContent = message || '';
    discountFeedback.classList.toggle('is-error', !!error);
  }

  /* =========================================================
     PRODUCT HANDLE
  ========================================================= */

  function getHandle(item) {
    if (item && item.handle) {
      return item.handle;
    }

    const match = String((item && item.url) || '').match(
      /\/products\/([^?/#]+)/
    );

    return match ? match[1] : '';
  }

  /* =========================================================
     PRODUCT META
  ========================================================= */

  async function getMeta(item) {
    const handle = getHandle(item);
    if (!handle) {
      return null;
    }

    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          })
      );
    }

    const product = await productCache.get(handle);
    if (!product) {
      return null;
    }

    const variant = (product.variants || []).find(function (v) {
      return String(v.id) === String(item.variant_id);
    });

    if (!variant) {
      return null;
    }

    return {
      compareAt: Number(variant.compare_at_price || 0),
      variantTitle:
        variant.title && variant.title !== 'Default Title'
          ? variant.title
          : ''
    };
  }

  /* =========================================================
     RESIZE IMAGE
  ========================================================= */

  function resized(src) {
    if (!src) {
      return '';
    }
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_160x200$1$2');
  }

  /* =========================================================
     LOADING STATE
  ========================================================= */

  function showLoadingState() {
    if (emptyState) {
      emptyState.style.display = 'none';
    }

    if (footer) {
      footer.style.display = 'none';
    }

    itemsContainer.innerHTML =
      '<div class="cart-drawer__loading" role="status" aria-live="polite">' +
      '<span class="cart-drawer__spinner" aria-hidden="true"></span>' +
      '<span>Updating your bag…</span>' +
      '</div>';
  }

  /* =========================================================
     HEADER LIVE COUNTER
  ========================================================= */

  function updateHeaderCount(count) {
    const total = Number(count || 0);

    document.querySelectorAll('.clh-cart-count').forEach(function (element) {
      element.textContent = total;
      element.hidden = total === 0;
      element.setAttribute('aria-hidden', total === 0 ? 'true' : 'false');
      element.setAttribute(
        'aria-label',
        total + ' item' + (total === 1 ? '' : 's') + ' in cart'
      );
    });

    const selectors = [
      '.cart-count',
      '.header__cart-count',
      '[data-cart-count]',
      '#cart-count',
      '.cart-item-count',
      '.cart-link__bubble-num',
      '.cart-count-bubble',
      '.cart-count-bubble span'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.classList.contains('clh-cart-count')) {
          return;
        }
        element.textContent = total;
        element.style.display = total > 0 ? '' : 'none';
        element.setAttribute(
          'aria-label',
          total + ' item' + (total === 1 ? '' : 's') + ' in cart'
        );
      });
    });

    document
      .querySelectorAll('[data-cart-count-number]')
      .forEach(function (element) {
        element.textContent = total;
        element.style.display = total > 0 ? '' : 'none';
      });

    if (titleCount) {
      titleCount.textContent = total;
      titleCount.hidden = total === 0;
    }
  }

  /* =========================================================
     TIER / REWARD
  ========================================================= */

  function updateTier(qty) {
    if (!tierMessage) {
      return;
    }

    const tiers = Array.isArray(cfg.tierDiscounts)
      ? cfg.tierDiscounts.slice().sort(function (a, b) {
          return Number(a.minItems) - Number(b.minItems);
        })
      : [];

    let current = null;

    tiers.forEach(function (tier) {
      if (qty >= Number(tier.minItems || 0)) {
        current = tier;
      }
    });

    const next = tiers.find(function (tier) {
      return qty < Number(tier.minItems || 0);
    });

    document.querySelectorAll('.lux-tier').forEach(function (element) {
      element.classList.remove('is-active');
    });

    if (current) {
      const active = document.querySelector(
        '.lux-tier[data-tier="' + current.tier + '"]'
      );
      if (active) {
        active.classList.add('is-active');
      }
    }

    if (next) {
      const need = Math.max(1, Number(next.minItems || 0) - qty);
      tierMessage.innerHTML =
        'Add <strong>' +
        need +
        '</strong> more item' +
        (need === 1 ? '' : 's') +
        ' to unlock <strong>' +
        Number(next.discount || 0) +
        '% off</strong> with code <strong>' +
        escapeHtml(next.code) +
        '</strong>';
    } else if (current) {
      tierMessage.innerHTML =
        'Quantity offer unlocked: <strong>' +
        Number(current.discount || 0) +
        '% off</strong> with code <strong>' +
        escapeHtml(current.code) +
        '</strong>';
    } else {
      tierMessage.textContent = 'Add items to unlock your exclusive offer.';
    }
  }

  /* =========================================================
     SELLING SUBTOTAL
  ========================================================= */

  function sellingSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      const linePrice =
        item.original_line_price != null
          ? Number(item.original_line_price)
          : Number(item.original_price || item.price || 0) *
            Number(item.quantity || 0);

      return sum + linePrice;
    }, 0);
  }

  /* =========================================================
     DISCOUNT HELPERS
  ========================================================= */

  function appliedCodeObjects(cart) {
    return (cart.discount_codes || []).filter(function (discount) {
      return discount && discount.code && discount.applicable !== false;
    });
  }

  function allocationTitle(allocation) {
    const application = (allocation && allocation.discount_application) || {};
    return String(
      application.title ||
        application.code ||
        allocation.title ||
        allocation.code ||
        ''
    ).trim();
  }

  function allocationAmount(allocation) {
    return Number(
      allocation && allocation.amount != null
        ? allocation.amount
        : allocation && allocation.total_allocated_amount != null
        ? allocation.total_allocated_amount
        : 0
    );
  }

  function couponSavings(cart) {
    const codes = appliedCodeObjects(cart).map(function (discount) {
      return String(discount.code);
    });

    const wanted = new Set(
      codes.map(function (code) {
        return code.toLowerCase();
      })
    );

    const byCode = {};
    codes.forEach(function (code) {
      byCode[code.toLowerCase()] = 0;
    });

    let matched = 0;

    function addAllocation(allocation) {
      const amount = allocationAmount(allocation);
      const title = allocationTitle(allocation).toLowerCase();

      if (!amount || !title || !wanted.has(title)) {
        return;
      }

      byCode[title] = (byCode[title] || 0) + amount;
      matched += amount;
    }

    (cart.items || []).forEach(function (item) {
      (
        item.line_level_discount_allocations ||
        item.discount_allocations ||
        []
      ).forEach(addAllocation);
    });

    (cart.cart_level_discount_applications || []).forEach(function (
      application
    ) {
      const title = String(
        application && (application.title || application.code || '')
      )
        .trim()
        .toLowerCase();

      const amount = Number((application && application.total_allocated_amount) || 0);

      if (amount && title && wanted.has(title)) {
        byCode[title] = (byCode[title] || 0) + amount;
        matched += amount;
      }
    });

    if (codes.length === 1 && matched === 0) {
      const totalDiscount = Number(cart.total_discount || 0);
      const selling = sellingSubtotal(cart);
      const total = Number(cart.total_price || 0);
      const derived = Math.max(0, selling - total);
      const fallback = Math.max(totalDiscount, derived);

      if (fallback > 0) {
        byCode[codes[0].toLowerCase()] = fallback;
        matched = fallback;
      }
    }

    return {
      total: matched,
      byCode: byCode
    };
  }

  /* =========================================================
     SUMMARY
  ========================================================= */

  async function updateSummary(cart, sequence) {
    const items = cart.items || [];
    const selling = sellingSubtotal(cart);

    if (sequence !== renderSeq) {
      return;
    }

    if (subtotalValue) {
      const subtotal = Number(
        cart.items_subtotal_price != null ? cart.items_subtotal_price : selling
      );
      subtotalValue.textContent = money(subtotal);
    }
  }

  /* =========================================================
     CREATE CART ITEM
  ========================================================= */

  function itemNode(item, index) {
    const fragment = itemTemplate.content.cloneNode(true);
    const card = fragment.querySelector('.cart-item');

    if (!card) {
      return fragment;
    }

    const title = card.querySelector('.cart-item__title');
    const image = card.querySelector('.cart-item__image');
    const imageLink = card.querySelector('.cart-item__image-link');
    const titleLink = card.querySelector('.cart-item__title-link');
    const price = card.querySelector('.cart-item__price');
    const comparePrice = card.querySelector('.cart-item__compare-price');
    const variantTitleEl = card.querySelector(
      '.cart-item__variant-title, .cart-item__variant'
    );
    const quantityValue = card.querySelector('.cart-item__qty-value');
    const minusButton = card.querySelector('.cart-item__qty-minus');
    const plusButton = card.querySelector('.cart-item__qty-plus');
    const removeButton = card.querySelector('.cart-item__remove');

    card.dataset.lineIndex = String(index + 1);
    card.dataset.lineKey = item.key || '';

    if (title) {
      title.textContent = item.product_title || item.title || '';
    }

    if (item.url) {
      if (imageLink) imageLink.setAttribute('href', item.url);
      if (titleLink) titleLink.setAttribute('href', item.url);
    }

    if (image) {
      image.src = resized(item.image);
      image.alt = item.product_title || item.title || '';
    }

    const unitPrice = Number(item.original_price || item.price || 0);
    const finalPrice = Number(item.final_price || item.price || 0);

    if (price) {
      price.textContent = money(finalPrice);
    }

    if (comparePrice) {
      comparePrice.hidden = true;
      comparePrice.textContent = '';
    }

    /* Variant / size next to price */
    if (variantTitleEl) {
      const vTitle =
        item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title
          : item.options_with_values
          ? item.options_with_values
              .map(function (o) {
                return o.value;
              })
              .join(' / ')
          : '';

      if (vTitle && vTitle !== 'Default Title') {
        variantTitleEl.textContent = 'Size: ' + vTitle;
        variantTitleEl.hidden = false;
        variantTitleEl.style.display = '';
      } else {
        variantTitleEl.textContent = '';
        variantTitleEl.hidden = true;
        variantTitleEl.style.display = 'none';
      }
    }

    if (quantityValue) {
      quantityValue.textContent = Number(item.quantity || 1);
    }

    if (minusButton) {
      minusButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (busy) return;
        changeLine(item.key, Math.max(0, Number(item.quantity || 0) - 1));
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (busy) return;

        changeLine(
          item.key,
          Number(item.quantity || 0) + 1
        );
      });
    }

    if (removeButton) {
      removeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (busy) return;
        changeLine(item.key, 0);
      });
    }

    getMeta(item)
      .then(function (meta) {
        if (!meta || !document.body.contains(card)) return;
        if (comparePrice && meta.compareAt > unitPrice) {
          comparePrice.textContent = money(meta.compareAt);
          comparePrice.hidden = false;
        }
      })
      .catch(function (error) {
        console.error('[HousiousCart Meta]', error);
      });

    return fragment;
  }

  /* =========================================================
     RENDER CART
  ========================================================= */

  function render(cart) {
    cartData = cart;
    const sequence = ++renderSeq;
    itemsContainer.innerHTML = '';

    const hasItems = Array.isArray(cart.items) && cart.items.length > 0;
    const totalQuantity = Number(cart.item_count || 0);

    if (emptyState) {
      emptyState.style.display = hasItems ? 'none' : 'flex';
    }

    if (footer) {
      footer.style.display = hasItems ? 'block' : 'none';
    }

    if (hasItems) {
      cart.items.forEach(function (item, index) {
        itemsContainer.appendChild(itemNode(item, index));
      });
    }

    updateTier(totalQuantity);
    updateHeaderCount(totalQuantity);

    updateSummary(cart, sequence).catch(function (error) {
      console.error('[HousiousCart Summary]', error);
    });
  }

  /* =========================================================
     FETCH CART
  ========================================================= */

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Could not load cart');
    }

    const cart = await response.json();
    render(cart);
    return cart;
  }

  /* =========================================================
     CHANGE QUANTITY
  ========================================================= */

  async function changeLine(lineKey, quantity) {
    if (busy || !lineKey) return;
    setBusy(true);

    const card = itemsContainer.querySelector(
      '[data-line-key="' + CSS.escape(String(lineKey)) + '"]'
    );
    if (card) {
      card.classList.add('is-updating');
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: Number(quantity)
        })
      });

      const cart = await response.json();
      if (!response.ok) {
        throw new Error(
          cart.description || cart.message || 'Could not update quantity'
        );
      }

      render(cart);
      updateHeaderCount(cart.item_count);

      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: { cart: cart } })
      );
    } catch (error) {
      console.error('[HousiousCart Quantity]', error);
      await fetchCart().catch(function () {});
    } finally {
      setBusy(false);
    }
  }

  /* =========================================================
     ADD TO CART
  ========================================================= */

  async function addToCart(variantId, quantity = 1, options = {}) {
    if (busy || !variantId) return;
    setBusy(true);

    const autoOpen = options.autoOpenDrawer !== false;
    if (autoOpen) {
      openDrawer(false);
      showLoadingState();
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(quantity)
        })
      });

      const data = await response.json().catch(function () {
        return {};
      });

      if (!response.ok) {
        throw new Error(
          data.description || data.message || 'Could not add product'
        );
      }

      const cart = await fetchCart();
      updateHeaderCount(cart.item_count);
    } catch (error) {
      console.error('[HousiousCart Add]', error);
      if (autoOpen) {
        await fetchCart().catch(function () {});
      }
    } finally {
      setBusy(false);
    }
  }

  /* =========================================================
     OPEN / CLOSE DRAWER
  ========================================================= */

  async function openDrawer(fetchFirst = true) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');

    document.body.classList.add('cart-drawer-open');

    if (fetchFirst) {
      await fetchCart().catch(function (error) {
        console.error('[HousiousCart Fetch]', error);
      });
    }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('cart-drawer-open');
  }

  /* =========================================================
     INTERCEPT CART LINKS AND BUTTONS
     (Prevents redirecting to /cart page)
  ========================================================= */

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(
      '[data-cart-toggle], a[href="/cart"], a[href$="/cart"]'
    );
    if (!trigger) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    openDrawer(true);
  });

  /* =========================================================
     ADD TO CART FORM INTERCEPTOR
  ========================================================= */

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest(
      '[data-type="add-to-cart-form"], form[action*="/cart/add"]'
    );
    if (!form) {
      return;
    }

    event.preventDefault();
    if (busy) return;

    const idInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');

    const variantId = Number(idInput ? idInput.value : 0);
    const quantity = Number(quantityInput ? quantityInput.value : 1) || 1;

    if (variantId) {
      await addToCart(variantId, quantity, { autoOpenDrawer: true });
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  overlay.addEventListener('click', closeDrawer);

  if (continueShopping) {
    continueShopping.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* =========================================================
     GLOBAL ADD-TO-CART HOOK
     Wishlist / quick-add / kisi bhi app ka add-to-cart
     -> cart page par nahi jayega, drawer auto open hoga
  ========================================================= */

  function isAddUrl(url) {
    return /\/cart\/add(\.js|\.json)?(\?|#|$)/.test(String(url || ''));
  }

  function openAfterExternalAdd() {
    openDrawer(true);
  }

  /* 1) fetch() hook */
  const nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    let url = '';
    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    } else if (input) {
      url = String(input);
    }

    const isAdd = isAddUrl(url);
    const internal = busy; /* drawer ka apna addToCart ho to dobara open na karo */

    if (isAdd) lastAddAt = Date.now();

    const promise = nativeFetch(input, init);

    if (isAdd && !internal) {
      promise
        .then(function (response) {
          if (response && response.ok) openAfterExternalAdd();
        })
        .catch(function () {});
    }

    return promise;
  };

  /* 2) XMLHttpRequest hook (kuch apps fetch ki jagah XHR use karte hain) */
  const nativeXhrOpen = XMLHttpRequest.prototype.open;
  const nativeXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cdIsAdd = isAddUrl(url);
    return nativeXhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__cdIsAdd) {
      const internal = busy;
      lastAddAt = Date.now();
      if (!internal) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) openAfterExternalAdd();
        });
      }
    }
    return nativeXhrSend.apply(this, arguments);
  };

  /* 3) form.submit() (programmatic) - isme "submit" event fire nahi hota */
  const nativeFormSubmit = HTMLFormElement.prototype.submit;

  HTMLFormElement.prototype.submit = function () {
    const action = this.getAttribute('action') || '';

    if (/\/cart\/add/.test(action)) {
      const idInput = this.querySelector('[name="id"]');
      const qtyInput = this.querySelector('[name="quantity"]');
      const variantId = Number(idInput ? idInput.value : 0);
      const quantity = Number(qtyInput ? qtyInput.value : 1) || 1;

      if (variantId) {
        addToCart(variantId, quantity, { autoOpenDrawer: true });
        return;
      }
    }

    return nativeFormSubmit.apply(this, arguments);
  };

  /* 4) Add ke turant baad app /cart par redirect kare to rok do
        (Chrome / Edge / Safari 26+ - Navigation API) */
  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function (event) {
      try {
        const dest = new URL(event.destination.url);

        if (
          dest.origin === window.location.origin &&
          /^\/cart\/?$/.test(dest.pathname) &&
          Date.now() - lastAddAt < 5000 &&
          event.cancelable &&
          !event.hashChange &&
          event.navigationType !== 'traverse'
        ) {
          event.preventDefault();
          openDrawer(true);
        }
      } catch (error) {}
    });
  }

  /* =========================================================
     PUBLIC CART API
  ========================================================= */

  window.CartDrawer = {
    open: function () {
      return openDrawer(true);
    },
    close: closeDrawer,
    addToCart: addToCart,
    fetchCart: fetchCart,
    changeLine: changeLine,
    updateHeaderCount: updateHeaderCount
  };

  /* =========================================================
     INITIALIZE COUNT
  ========================================================= */

  nativeFetch('/cart.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      return response.ok ? response.json() : Promise.reject();
    })
    .then(function (cart) {
      cartData = cart;
      updateHeaderCount(cart.item_count);
    })
    .catch(function () {});
})();